import Vue from 'vue'
import './setupComposition'

import Vuelidate from 'vuelidate'

import 'vue-awesome/icons'
import MaxLenFilter from '@/filters/maxLen'
import NoHashTagsFilter from '@/filters/noHashTags'
import CleanHashtagsFilter from '@/filters/cleanHashTags'
import BytesFilter from '@/filters/bytes'
import DateFilter from '@/filters/date'

import VTooltip from 'v-tooltip'
import { hasFeature } from './featureFlags/featureFlags'
import { setupVueEnv as setupAbilities } from './ability'

setupAbilities()
Vue.filter(MaxLenFilter.name, MaxLenFilter.fn)
Vue.filter(NoHashTagsFilter.name, NoHashTagsFilter.fn)
Vue.filter(CleanHashtagsFilter.name, CleanHashtagsFilter.fn)
Vue.filter(BytesFilter.name, BytesFilter.fn)
Vue.filter(DateFilter.name, DateFilter.fn)

Vue.use(Vuelidate as any)
Vue.use(VTooltip)

// @ts-ignore
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

import PortalVue from 'portal-vue'
import studio from './modules/database/utils'


// FIXME should only be here for jest
Vue.config.productionTip = false
Vue.config.devtools = false
Vue.prototype.$hasFeature = hasFeature

if (process.env.NODE_ENV === 'test') {
  // In the vue test environment, we want the modals to be shown inside the component. Else we cannot query them.
  // We cannot use the same approach as in the production environment, because the modals are not rendered op top
  // https://github.com/LinusBorg/portal-vue/issues/260
  Vue.config.ignoredElements = ['portal']
} else {
  // In production they are showed in the App.vue component on top of everything
  Vue.use(PortalVue)
}


Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    // @ts-ignore
    el.event = event => {
      if (!(el === event.target || el.contains(event.target))) {
        if (vnode && vnode.context && binding.expression) {
          // @ts-ignore
          vnode.context[binding.expression](event)
        }
      }
    }
    // @ts-ignore
    document.body.addEventListener('click', el.event)
  },
  unbind: function (el) {
    // @ts-ignore
    document.body.removeEventListener('click', el.event)
  }
})

try {
  afterEach(() => {
    if (studio.subscriptions.runningKeys().length > 0) {
      console.error('Running keys are still', studio.subscriptions.runningKeys())
      studio.subscriptions.runningKeys().forEach((key) => studio.subscriptions.unsubscribeFB(key))
    }
  })
  afterAll(() => {
    jest.restoreAllMocks()
    global.gc && global.gc()
  })
  /* process.on('unhandledRejection', reason => {
    throw reason
  }) */
} catch (_error) {}
